module.exports = __webpack_public_path__ + "static/media/hack-logo.8d8c584b.jpg";